import { render, staticRenderFns } from "./MessageIcon.vue?vue&type=template&id=18c93b68&"
import script from "./MessageIcon.vue?vue&type=script&lang=js&"
export * from "./MessageIcon.vue?vue&type=script&lang=js&"
import style0 from "./MessageIcon.vue?vue&type=style&index=0&id=18c93b68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports